import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import MaterialTypeLink from '../MaterialTypeLink';
import './MaterialTypeFilterLinks.scss';

export default function MaterialTypeFilterLinks({ materialTypeCounts }) {
  return (
    <span className="cp-material-type-filter-links">
      <MaterialTypeLink materialType={undefined}>
        <FormattedMessage id="filter_material_type_all" />
      </MaterialTypeLink>
      {
          materialTypeCounts.map((count, materialType) => (
            <span key={`material-type-${materialType}`}>
              <span className="material-type-divder">|</span>
              <MaterialTypeLink count={count} materialType={materialType} />
            </span>
          )).toArray()
      }
    </span>
  );
}

MaterialTypeFilterLinks.propTypes = {
  materialTypeCounts: ImmutablePropTypes.map
};



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/MaterialTypeFilterLinks/MaterialTypeFilterLinks.jsx